<template>
  <footer class="site-footer">
    <div class="container">
      <div class="row clearfix">
        <div class="company">
          <div class="logo-box">
            <h1 class="sm">
              <span class="logo"></span>
            </h1>
            <span class="copyright">
              Copyright ISUNG Corp. All Rights Reserved
            </span>
          </div>
          <div class="link">
            <a
              href="javascript:"
              @click.prevent="isCUPopupOpened = true"
              v-text="$t('footer.customer_center')"
            ></a>
            <router-link
              to="/help/policy/privacy"
              v-text="$t('footer.privacy_policy')"
            ></router-link>
            <router-link
              to="/help/policy/tos"
              v-text="$t('footer.use_policy')"
            ></router-link>
          </div>
        </div>
        <div class="info">
          <p v-text="$t('footer.ip_desc')"></p>
          <div class="lang">
            <img src="@assets/images/icon-language.png" alt="Language" />
            <select v-model="selected_lang" @change="changeLanguage">
              <option value="ko">한국어</option>
              <option value="ja">日本語</option>
              <option value="en">English</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <PopupContactUs :opened="isCUPopupOpened" @popupOff="onCUPopup" />
  </footer>
</template>

<script>
import Cookies from 'js-cookie';
import { Common } from '@src/common';
import PopupContactUs from '@components/PopupContactUs.vue';

export default {
  name: 'Footer',
  components: {
    PopupContactUs,
  },
  data() {
    return {
      selected_lang: '',
      isCUPopupOpened: false,
    };
  },
  created() {
    this.selected_lang = Cookies.get(Common.STORAGE_LANG);
  },
  methods: {
    changeLanguage() {
      Cookies.set(Common.STORAGE_LANG, this.selected_lang);
      window.location.reload();
    },
    onCUPopup() {
      this.isCUPopupOpened = !this.isCUPopupOpened;
    },
  },
};
</script>

<style scoped lang="scss">
.site-footer {
  margin-top: 48px;
  padding: 24px 0;

  .company {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo-box {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .logo-box h1 + span {
      margin-left: 24px;
      color: $gray-88;
      letter-spacing: 0;
    }

    .link {
      display: flex;
      align-items: center;
      margin-left: 24px;
      padding-bottom: 10px;
    }

    .link a {
      padding: 0 6px;
      font-size: 11px;
      color: $gray-88;
    }

    .link a + a {
      border-left: 1px solid $gray-e6;
    }

    .link a:last-child {
      padding-right: 0;
    }
  }

  .info {
    width: 100%;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    .lang {
      margin-left: 36px;
      display: flex;
      align-items: center;
    }

    .lang select {
      width: 58px;
      height: auto;
      margin-left: 4px;
      padding-left: 4px;
      border: 0 none;
      background-color: transparent;
      background-position: right center;
    }
  }
}
</style>
